/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalArticleDiscountsRequest } from '../../models/global-article-discounts-request';

export interface ApplyGlobalArticleDiscounts$Params {
  id: number;
      body: GlobalArticleDiscountsRequest
}

export function applyGlobalArticleDiscounts(http: HttpClient, rootUrl: string, params: ApplyGlobalArticleDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, applyGlobalArticleDiscounts.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

applyGlobalArticleDiscounts.PATH = '/offers/{id}/articles/global-discounts';
